import InitiativeBoxSvg from './InitiativeBoxSvg';

export default InitiativeBoxSvg;
export { InitiativeBoxSvg };
